import * as React from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

// MATERIAL UI
import { Stepper, Step, StepLabel, Button, StepConnector, withStyles, makeStyles, CircularProgress } from '@material-ui/core';
import Notification from '../../components/Notification';
import Cookies from '../../components/Cookies';


// CONTAINERS

// import CarModelPage from '../CarModelPage';
// import CarDamagePage from '../CarDamagePage';
// import FormPages from '../FormPages';
import LicensePlate from '../../components/LicensePlate/index';
const CarModelPage = React.lazy(() => import('../CarModelPage'));
const CarDamagePage = React.lazy(() => import('../CarDamagePage'));
const FormPages = React.lazy(() => import('../FormPages'));

// import CarModelPage from '../CarModelPage';
// import CarDamagePage from '../CarDamagePage';
// import FormPages from '../FormPages';


// TYPES
import { Store, Photo } from '../../types'

// HELPERS
import { getPartnerId } from '../../helpers'

//ACTIONS
import { submitFormUser } from '../../store/actions/car';
import { fetchGlobalSetting } from '../../store/actions/settings';
import { fetchPartnerData } from '../../store/actions/car';

//STYLES
import './styles.scss'

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 20,

  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,var(--color_primary) 0%, var(--color_highlight) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,var(--color_primary) 0%, var(--color_highlight) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: 'gray',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: 'gray',
    zIndex: 1,
    color: '#fff',
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
      'linear-gradient( 95deg,var(--color_primary) 0%, var(--color_highlight) 100%)'
  },
  completed: {
    backgroundImage:
      'linear-gradient( 95deg,var(--color_primary) 0%, var(--color_highlight) 100%)',
  },
});

function ColorlibStepIcon(props: any) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={classes.root + ` ${active ? classes.active : ''}` + ` ${completed ? classes.completed : ''}`}>
      {props.icon}
    </div>
  );
}



const bc: string = 'main-page'

function getSteps() {
  return ['Skadornas placering', 'Bilder', 'Ytterligare information'];
}

function getStepContent(stepIndex: number) {
  switch (stepIndex) {
    case 0:
      return <CarModelPage />;
    case 1:
      return <CarDamagePage />;
    case 2:
      return <FormPages />;
    default:
      return <CarModelPage />;
  }
}

type State = {
  activeStep: number,
  isDamaged: boolean
}

type Props = {

}

type InjectProps = {
  damages: string[],
  submitFormUser: (cd: () => void) => void;
  errors: Array<string>,
  fetchGlobalSetting: () => void;
  photos: any,
  fetchPartnerData: (history: any) => void;
  partner: any;
  settings: any;
  history: any;
  isFormSubmitting: boolean;
}

class HorizontalLabelPositionBelowStepper extends React.Component<Props & InjectProps, State> {
  state = {
    activeStep: 0,
    isDamaged: false,
  };

  //COMPONENT LIFECYCLE
  componentDidMount() {
    const { fetchGlobalSetting, fetchPartnerData, history } = this.props;
    fetchGlobalSetting();
    fetchPartnerData(history);
  }


  //METHODS
  handleReset = () => {

    this.setState({
      activeStep: 0,
    });
    this.props.history.push('/thanks');
  };

  reloadCations = () => {
    let result = confirm('Är du säker på att du vill börja om? Markerade områden, bilder och formulär kommer att tömmas. och du kommer att skickas till steg 1.');

    if (result) {
      document.location.reload();
      localStorage.removeItem('persist:root');
    }
  }

  handleNext = () => {
    const steps = getSteps();
    const { activeStep } = this.state;
    const { submitFormUser, errors } = this.props;

    window.scrollTo(pageXOffset, 0);

    if (activeStep < steps.length - 1) {
      this.setState((state: State) => ({
        activeStep: state.activeStep + 1,
      }));
    }

    //if (errors.length && activeStep === steps.length - 1){
      //  console.log("HEJ")
        //return;
    //}
    
    //if (activeStep === steps.length - 1 && !errors.length)
    if (activeStep === steps.length - 1) {
      submitFormUser(this.handleReset);

      this.setState((state: State) => ({
        activeStep: state.activeStep
      }));
    }
  };

  handleBack = () => {
    this.setState((state: State) => ({
      activeStep: state.activeStep - 1,
    }));

    window.scrollTo(pageXOffset, 0);
  };


  setDamage = (arg: boolean) => {
    this.setState({ isDamaged: arg })
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {

    if (e.target) {
      const newState: any = { [e.target.name]: e.target.value };
      this.setState(newState);
    } else {
      const newState: any = { date: e.target.value }
      this.setState(newState);
    }
  }

  disableButton = () => {
    const isProd = process.env.NODE_ENV === 'production';
   // if (isProd === false) { return false; }

    const { activeStep } = this.state;
    const { photos, errors, isFormSubmitting } = this.props;

    let isOverviewHaveImages = photos.overview[0].images.length > 0;
    let isCloseUpHaveImages = photos.close_ups.length && photos.close_ups.every((el: Photo) => {
      if (el.images.length) return true;

      return false;
    });

    switch (activeStep) {
      case 0:
        return photos.close_ups.length === 0;
      case 1:
        return !isOverviewHaveImages || !isCloseUpHaveImages;
      case 2:
        if (errors.includes("reg_nr")) {
            try {
                const regno = (document.getElementById('reg_nr') as HTMLInputElement).value;
                if (regno.length === 6) {
                    return false;
                }
                document.getElementById('reg_nr').classList.add('error')
                return true;
            }
            catch {
                return true;
            }
        }
        return errors.length > 0 || isFormSubmitting;
    }
  }

  renderMain = () => {
    const steps = getSteps();
    const { activeStep } = this.state;
    const { partner, settings, isFormSubmitting } = this.props;
    
    return (<>
      <React.Suspense fallback={<div className={'overlay'}><CircularProgress /></div>}>

        {partner == null || !partner.id || isFormSubmitting ? <div className={bc + '__preload_screen'}><CircularProgress /></div> : null}

        {settings.id ? <Notification /> : null}
        <Cookies />
        <Stepper activeStep={activeStep} alternativeLabel connector={<ColorlibConnector />}>
          {steps.map(label => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>{getStepContent(activeStep)}</div>
        {activeStep === 1 && this.disableButton() ? <div className={bc + '__alert-block'} >Var god ladda upp bilder för alla områden innan denna knapp kan aktiveras</div> : null}
        <div className={bc + '__stepper' + `${activeStep ? '__active' : ''}`}>
          {activeStep ? (<Button
            variant="contained"
            color="primary"
            disabled={activeStep === 0}
            onClick={this.handleBack}
            style={{ background: `var(--color_primary)` }}
          >
            Tillbaka
          </Button>) :
            null
          }
          <div className={bc + '__spinner-block'}>
            {isFormSubmitting ? <div className={bc + '__spinner-block' + '__spinner-container'}><CircularProgress style={{ color: `var(--color_highlight)`, width: '36px', height: '36px' }} /></div> : null}
            <Button variant="contained" style={{ color: 'white', background: `${!this.disableButton() ? 'var(--color_highlight)' : 'rgb(211,211,211)'}` }} color="secondary" onClick={this.handleNext} disabled={this.disableButton()}>
              {activeStep === steps.length - 1 ? 'Skicka' : 'Nästa'}
            </Button>
          </div>
        </div>
        <div className={bc + '__reload-block'}>
          <Button variant="contained" style={{ color: 'red', background: `white` }} color="secondary" onClick={this.reloadCations}>
            {'Börja om'}
          </Button>
        </div>
      </React.Suspense>
    </>)
  }

  renderError = () => {
    return (
      <div className={'error-message'}><div className={'error-message' + '__text'}>Den här sidan är inte tillgänglig för angiven partner.</div></div>
    )
  }

  //RENDER
  render() {

    // const { partner, errors } = this.props;
    const partner_id = getPartnerId();

    return (
      <>
        {/* {partner && partner['id'] ? this.renderMain() : this.renderError()} */}
        {/* {partner && partner['id'] ? this.renderMain() : this.renderError()} */}
        {/* {errors.length == 0 ? this.renderMain() : this.renderError()} */}
        {/* {partner_id ? this.renderMain() : this.renderError()} */}
        {!partner_id || partner_id.trim().length == 0 ? this.renderError() : this.renderMain()}
      </>
    );
  }
}


//DISPATCH
const mapDispatchToProps = {
  submitFormUser,
  fetchGlobalSetting,
  fetchPartnerData
}


//STORE PROPS
const mapStateToProps = (state: Store) => {
  return {
    damages: state.car.damages,
    errors: state.car.form.errors,
    photos: state.car.photos,
    partner: state.car.partner,
    settings: state.settings,
    isFormSubmitting: state.car.isFormSubmitting
  }
};


// HOC
export default withRouter(connect<any, any, any>(mapStateToProps, mapDispatchToProps)(HorizontalLabelPositionBelowStepper));